var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('k-progress',{staticStyle:{"width":"100%"},attrs:{"percent":_vm.value,"color":_vm.getColor}})}
var staticRenderFns = []

export { render, staticRenderFns }